import { withStyles } from '@material-ui/core/styles';
import styles from './FloatingControlsContainer.styles';
import FloatingControlsContainer from './FloatingControlsContainer';

export default withStyles(styles)(FloatingControlsContainer);
